import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom'
import SubMenu from './SubMenu';

function Layout() {
        const [isSticky, setIsSticky] = useState(false);
        useEffect(() => {
          const handleScroll = () => {
            const scrollPosition = window.scrollY;
            const threshold = 100;
            setIsSticky(scrollPosition > threshold);
          };
          window.addEventListener('scroll', handleScroll);
          return () => {
            window.removeEventListener('scroll', handleScroll);
          };
        }, []);

        // hamburger menu
 
  return (
    <div>
    <div className="topbar">
    <div className="container">
        <div className="topbar_inner">
            <div className="row">
                <div className="col-lg-6">
                    <ul className="left_side top_list">
                        <li>
                            <Link to="#">
                                <i className="bi bi-telephone-fill"></i>
                                123-456-7890
                            </Link>
                        </li>
                        <li>
                            <Link to="#">
                                <i className="bi bi-alarm-fill"></i>
                                Mon To Fri: 4am - 11:00pm
                            </Link>
                        </li>
                    </ul>
                </div>
                <div className="col-lg-6">
                    <ul className="right_side top_list">
                        <li className="search_bar">
                            <form className="input-group">
                                <input type="text" name="#" className="search_input" placeholder="Search..." autoComplete="off" required/>
                                <div className="input-group-append ms-0">
                                    <button type="submit">
                                        <i className="fal fa-search"></i>
                                    </button>
                                </div>
                            </form>
                        </li>
                        <li>
                            <Link to="#">
                                <i className="fab fa-facebook-f"></i>
                            </Link>
                        </li>
                        <li>
                            <Link to="#">
                                <i className="fab fa-twitter"></i>
                            </Link>
                        </li>
                        <li>
                            <Link to="#">
                                <i className="fab fa-instagram"></i>
                            </Link>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    </div>
    <header className={`header-nav header ${isSticky ? 'sticky' : ''}`}>
        <div className="container navigation-werpar">
            <div className="head_top">
                <div className="logo">
                    <Link to="/">
                        <img src="/tm/react/fit2fine/assets/images/logo.png" alt="logo" className="image-fit-contain"/>
                    </Link>
                </div>
            </div>
            <nav className='navigation'>
                <ul className='navigation main-menu'>
                    <li className="menu-item menu-item-has-children">
                        <Link to="#"  className="active">Home</Link>
                        <ul className="sub-menu">
                            <li className="menu-item">
                                <Link to="">Homepage v1</Link>
                            </li>
                            <li className="menu-item">
                                <Link to="/home-v2" >Homepage v2</Link>
                            </li>
                        </ul>
                    </li>
                    <li className="menu-item">
                        <Link to="/about" >About</Link>
                    </li>
                    <li className="menu-item menu-item-has-children">
                        <Link to="#" >Blog</Link>
                        <ul className="sub-menu">
                            <li className="menu-item menu-item-has-children">
                                <Link to="#" >Blog Grid</Link>
                              
                                <ul className="sub-menu">
                                    <li className="menu-item">
                                        <Link to="/blog-grid" >Full Width</Link>
                                    </li>
                                    <li className="menu-item">
                                        <Link to="/blog-grid-left" >Left Sidebar</Link>
                                    </li>
                                    <li className="menu-item">
                                        <Link to="/blog-grid-right" >Right Sidebar</Link>
                                    </li>
                                </ul>
                             
                            </li>
                            <li className="menu-item">
                                <Link to="/blog-details" >Blog Details</Link>
                            </li>
                        </ul>
                    </li>
                    <li className="menu-item menu-item-has-children">
                        <Link to="#" >Pages</Link>
                       
                        <ul className="sub-menu">
                            <li className="menu-item">
                                <Link to="/services" >Services</Link>
                            </li>
                            <li className="menu-item">
                                <Link to="/team" >Team</Link>
                            </li>
                            <li className="menu-item">
                                <Link to="/trainer" >Trainer</Link>
                            </li>
                            <li className="menu-item">
                                <Link to="/schedule" >Schedule</Link>
                            </li>
                            <li className="menu-item">
                                <Link to="/pricing" >Pricing</Link>
                            </li>
                            <li className="menu-item">
                                <Link to="/program" >Program</Link>
                            </li>
                            <li className="menu-item">
                                <Link to="/gallery" >Gallery</Link>
                            </li>
                        </ul>
                       
                    </li>
                    <li className="menu-item">
                        <Link to="/contact" >Contact</Link>
                    </li>
                </ul>
                    <SubMenu/>
            </nav>
        </div>
    </header>
    </div>
  )
}

export default Layout